// this is an autogenerated file from App/Account/Content/Settings/Content/ConnectApps/App/Content/Connections/Content/ActionsColumn/Actions/Content/SyncAction/Content/LastSyncStatus/data.graphql
import { gql } from 'Data/Api'

export default gql`
subscription app__App_Account_Content_Settings_Content_ConnectApps_App_Content_Connections_Content_ActionsColumn_Actions_Content_SyncAction_Content_LastSyncStatus($connection_id: uuid!, $location_id: uuid!) {
  apps_sync(
    where: {
      connection_id: { _eq: $connection_id }
      location_id: { _eq: $location_id }
    }
    order_by: { created_at: desc }
  ) {
    id
    status
    updated_at
  }
}

`